// This file was once generated when you created this area
// but you can edit it freely

import { transformRoutes } from '@backoffice-frontend/common'

export const BaseVehicleGroupAreaRoutes = {
  route: '/vehicle-groups',
  title: 'Vehicle configurations',
  Show: {
    route: `/:vehicleGroupId`,
  },
}

export const VehicleGroupAreaRoutes = transformRoutes(
  BaseVehicleGroupAreaRoutes,
)
